import { render, staticRenderFns } from "./WarehouseDetail.vue?vue&type=template&id=98d04ddc&scoped=true&"
import script from "./WarehouseDetail.vue?vue&type=script&lang=js&"
export * from "./WarehouseDetail.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseDetail.vue?vue&type=style&index=0&id=98d04ddc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d04ddc",
  null
  
)

export default component.exports